import { defineMessages } from '@jutro/locale';

export default defineMessages({
    paymentHeader: {
        id: 'portal.components.transactionWizardTitle.transactionWizardTitle.Policy Change - Homeowners',
        defaultMessage: 'Policy Change - Homeowners'
    },
    accountTitleHo: {
        id: 'endorsement.directives.templates.bank-account-details-quote.Account:',
        defaultMessage: 'Account:'
    },
    hoPolicyChangeCoverages: {
        id: 'endorsement.ho.directives.templates.ho-coverages.Coverages',
        defaultMessage: 'Coverages'
    },
    hoPolicyChangeValuables: {
        id: 'endorsement.ho.directives.templates.ho-valuables.Valuables',
        defaultMessage: 'Valuables'
    },
    hoPolicyChangeMortgagee: {
        id: 'endorsement.ho.directives.templates.ho-mortgagee.Mortgagee',
        defaultMessage: 'Mortgagee'
    },
    hoPolicyChange: {
        id: 'endorsement.ho.directives.templates.ho-policy-changes.Policy Changes',
        defaultMessage: 'Policy Changes'
    },
    hoPolicyChangeQuotes: {
        id: 'endorsement.common.views.history.Quote',
        defaultMessage: 'Quote'
    },
    hoPolicyChangeBillingDetails: {
        id: 'endorsement.ho.directives.templates.ho-coverages.BillingDetails',
        defaultMessage: 'Billing Details'
    },
    anErrorOccurred: {
        id: 'gw-portals-policytransaction-pc-ho.wizard.error',
        defaultMessage: 'Something went wrong during this process.'
    },
    anErrorOccurredTitle: {
        id: 'gw-portals-policytransaction-pc-ho.wizard.error.title',
        defaultMessage: 'Error'
    },
    saveQuoteError: {
        id: 'gw-portals-policytransaction-pc-ho.Unable to quote',
        defaultMessage: 'Unable to quote'
    },
    saveQuoteErrorMessage: {
        id: 'gw-portals-policytransaction-pc-ho.An error occurred while attempting to quote.',
        defaultMessage: 'An error occurred while attempting to quote.'
    },
    mlChooseEffectiveDate: {
        id: 'ml.endorsement.ho.directives.templates.ho-effectiveDate.mlChooseEffectiveDate',
        defaultMessage: 'Choose Effective Date'
    },
    mlDiscounts: {
        id: 'ml.gw-portals-policytransaction-pc-ho.Discounts',
        defaultMessage: 'Discounts'
    },
    mlPropertyDetails: {
        id: 'ml.gw-portals-policytransaction-pc-ho.Property Details',
        defaultMessage: 'Property Details'
    },
    mlEmployersAffiliations: {
        id: 'ml.endorsement.ho.directives.templates.ho-effectiveDate.mlEmployersAffiliations',
        defaultMessage: 'Employer/Affiliation'
    },
    mlPayments: {
        id: 'ml.gw-portals-policytransaction-pc-ho.Payments',
        defaultMessage: 'Payments'
    },
    mlAdditionalPolicyInfo: {
        id: 'ml.gw-portals-policytransaction-pc-ho.Additional Policy Info',
        defaultMessage: 'Additional Policy Info'
    },
    makeChanges: {
        id: 'ml.gw-portals-policytransaction-pc-ho.Make Changes',
        defaultMessage: 'Make Changes'
    },
    mlQuoteDetails: {
        id: 'ml.gw-portals-policytransaction-pc-ho.Quote Details',
        defaultMessage: 'Quote Details'
    },
    addresses: {
        id: 'ml.gw-portals-policytransaction-pc-ho.Addresses',
        defaultMessage: 'Addresses'
    },
    confirmation: {
        id: 'ml.gw-portals-policytransaction-pc-ho.Policy change confirmation',
        defaultMessage: 'Policy change confirmation'
    },
    loadingPolicyChange: {
        id: 'ml.gw-portals-policytransaction-pc-ho.Loading policy change',
        defaultMessage: 'Loading policy change'
    }
});
